import React from 'react';
import { DecoratorNode } from 'lexical';

import LatexRenderer from '../../../latex/renderer/LatexRenderer';

export default class LatexNode extends DecoratorNode<React.JSX.Element> {
    __latex: string;
    __color: string;

    constructor(latex: string, color = 'inherit', key?: string) {
        super(key);
        this.__latex = latex;
        this.__color = color;
    }

    static getType(): string {
        return 'latex';
    }

    static clone(node: LatexNode): LatexNode {
        return new LatexNode(node.__latex, node.__color, node.__key);
    }

    exportJSON() {
        return {
            type: 'latex',
            version: 1,
            latex: this.__latex,
            color: this.__color,
        };
    }

    static importJSON(serialized: any): LatexNode {
        return new LatexNode(serialized.latex, serialized.color);
    }

    createDOM(): HTMLElement {
        return document.createElement('span');
    }

    updateDOM(): boolean {
        return false;
    }

    decorate(): React.JSX.Element {
        return React.createElement(LatexRenderer, {
            latex: this.__latex,
            color: this.__color,
        });
    }
}
